module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("Letter Template")]), _vm._v(" "), _c('div', {}, [(_vm.loading) ? _c('loader') : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('form', {
    staticClass: "form form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Template Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.letterTemplate.templateName),
      expression: "letterTemplate.templateName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.letterTemplate.templateName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.letterTemplate, "templateName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Template Type")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.letterTemplate.letterTemplateTypeId),
      expression: "letterTemplate.letterTemplateTypeId"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.letterTemplate, "letterTemplateTypeId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Select Template Type")]), _vm._v(" "), _vm._l((_vm.templateTypeList), function(type) {
    return _c('option', {
      key: type.id,
      domProps: {
        "value": type.id
      }
    }, [_vm._v(_vm._s(type.description))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Generate on Workflow")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.letterTemplate.workflowStatusId),
      expression: "letterTemplate.workflowStatusId"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.letterTemplate, "workflowStatusId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("None")]), _vm._v(" "), _c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("--- Fieldwork Request (FWR) ---")]), _vm._v(" "), _vm._l((_vm.fieldworkWfsList), function(status) {
    return _c('option', {
      key: status.workflowStatusId,
      domProps: {
        "value": status.workflowStatusId
      }
    }, [_vm._v("FWR - " + _vm._s(status.description))])
  }), _vm._v(" "), _c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("------ File Search (FIS) ------")]), _vm._v(" "), _vm._l((_vm.fileSearchWfsList), function(status) {
    return _c('option', {
      key: status.workflowStatusId,
      domProps: {
        "value": status.workflowStatusId
      }
    }, [_vm._v("FIS - " + _vm._s(status.description))])
  }), _vm._v(" "), _c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("----- Investigation (INV) -----")]), _vm._v(" "), _vm._l((_vm.investigationWfsList), function(status) {
    return _c('option', {
      key: status.workflowStatusId,
      domProps: {
        "value": status.workflowStatusId
      }
    }, [_vm._v("INV - " + _vm._s(status.description))])
  }), _vm._v(" "), _c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("- Cultural Resource Recording (CRR) -")]), _vm._v(" "), _vm._l((_vm.crrWfsList), function(status) {
    return _c('option', {
      key: status.workflowStatusId,
      domProps: {
        "value": status.workflowStatusId
      }
    }, [_vm._v("CRR - " + _vm._s(status.description))])
  }), _vm._v(" "), _c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("-------- Isolate (ISO) --------")]), _vm._v(" "), _vm._l((_vm.isolateWfsList), function(status) {
    return _c('option', {
      key: status.workflowStatusId,
      domProps: {
        "value": status.workflowStatusId
      }
    }, [_vm._v("ISO - " + _vm._s(status.description))])
  }), _vm._v(" "), _c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("-- Site Number Request (SNR) --")]), _vm._v(" "), _vm._l((_vm.siteNumberRequestWfsList), function(status) {
    return _c('option', {
      key: status.workflowStatusId,
      domProps: {
        "value": status.workflowStatusId
      }
    }, [_vm._v("SNR - " + _vm._s(status.description))])
  }), _vm._v(" "), _c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("---- Building Survey (BUS) ----")]), _vm._v(" "), _vm._l((_vm.buildingSurveyWfsList), function(status) {
    return _c('option', {
      key: status.workflowStatusId,
      domProps: {
        "value": status.workflowStatusId
      }
    }, [_vm._v("BUS - " + _vm._s(status.description))])
  }), _vm._v(" "), _c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("------ Undertaking (UND) ------")]), _vm._v(" "), _vm._l((_vm.undertakingWfsList), function(status) {
    return _c('option', {
      key: status.workflowStatusId,
      domProps: {
        "value": status.workflowStatusId
      }
    }, [_vm._v("UND - " + _vm._s(status.description))])
  }), _vm._v(" "), _c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("------------- MOA -------------")]), _vm._v(" "), _vm._l((_vm.moaWfsList), function(status) {
    return _c('option', {
      key: status.workflowStatusId,
      domProps: {
        "value": status.workflowStatusId
      }
    }, [_vm._v("MOA - " + _vm._s(status.description))])
  }), _vm._v(" "), _c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("------------- PA --------------")]), _vm._v(" "), _vm._l((_vm.paWfsList), function(status) {
    return _c('option', {
      key: status.workflowStatusId,
      domProps: {
        "value": status.workflowStatusId
      }
    }, [_vm._v("PA - " + _vm._s(status.description))])
  }), _vm._v(" "), _c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("--- E106 Compliance (E106) ----")]), _vm._v(" "), _vm._l((_vm.e106WfsList), function(status) {
    return _c('option', {
      key: status.workflowStatusId,
      domProps: {
        "value": status.workflowStatusId
      }
    }, [_vm._v("E106 - " + _vm._s(status.description))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Secondary Condition")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.letterTemplate.secondaryConditionId),
      expression: "letterTemplate.secondaryConditionId"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.letterTemplate, "secondaryConditionId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("None")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("Undertaking is Notify and Proceed")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("Undertaking is Notify and Proceed & BLM is Lead Agency")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3
    }
  }, [_vm._v("Undertaking is Notify and Proceed & USFS is Lead Agency")])])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "name": "dataReference"
    },
    on: {
      "click": function($event) {
        _vm.$refs['dataFieldModal'].open()
      }
    }
  }, [_vm._v("Data Fields Reference")]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('editor', {
    attrs: {
      "id": "editor",
      "init": _vm.editor.options
    },
    model: {
      value: (_vm.letterTemplate.templateBody),
      callback: function($$v) {
        _vm.$set(_vm.letterTemplate, "templateBody", $$v)
      },
      expression: "letterTemplate.templateBody"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group spacer"
  }, [_c('div', {
    staticClass: "col-sm-2"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "name": "saveTemplate"
    },
    on: {
      "click": _vm.saveTemplate
    }
  }, [_vm._v("Save Template")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "name": "button1"
    },
    on: {
      "click": _vm.getLetterPreview
    }
  }, [_vm._v("Preview Sample Letter")])])])]) : _vm._e(), _vm._v(" "), _c('modal', {
    ref: "dataFieldModal"
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h3', {
    staticClass: "pull-left"
  }, [_vm._v("Data Fields Reference")]), _vm._v(" "), _c('button', {
    staticClass: "btn pull-right",
    on: {
      "click": function($event) {
        _vm.$refs['dataFieldModal'].close()
      }
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('v-client-table', {
    attrs: {
      "data": _vm.tableData,
      "columns": _vm.gridSpec.columns,
      "options": _vm.gridSpec.options
    },
    scopedSlots: _vm._u([{
      key: "insert",
      fn: function(props) {
        return [_c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('a', {
          staticClass: "fa fa-paste",
          staticStyle: {
            "font-size": "18px"
          },
          on: {
            "click": function($event) {
              _vm.copyAndInsertDataField(props.row.dataField)
            }
          }
        })])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn btn-primary col-md-3",
    attrs: {
      "type": "button",
      "name": "cancel"
    },
    on: {
      "click": function($event) {
        _vm.$refs['dataFieldModal'].close()
      }
    }
  }, [_vm._v("Close")])])])]), _vm._v(" "), _c('modal', {
    ref: "letterPreviewModal"
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h3', {
    staticClass: "pull-left align-bottom"
  }, [_vm._v("Letter Body Preview")]), _vm._v(" "), _c('button', {
    staticClass: "btn pull-right",
    on: {
      "click": function($event) {
        _vm.$refs['letterPreviewModal'].close(), _vm.closeLetterAlert()
      }
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [(_vm.letterPreviewLoading) ? _c('loader') : _vm._e(), _vm._v(" "), (!_vm.letterPreviewLoading) ? _c('div', [_c('editor', {
    attrs: {
      "id": "editorPreview",
      "init": _vm.editorPreview.options
    },
    model: {
      value: (_vm.editorPreview.previewContent),
      callback: function($$v) {
        _vm.$set(_vm.editorPreview, "previewContent", $$v)
      },
      expression: "editorPreview.previewContent"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px",
      "width": "99%"
    }
  }, [_c('div', {
    staticClass: "alert alert-success alert-dismissible",
    class: {
      'hidden': _vm.letterAlertHidden
    },
    attrs: {
      "role": "alert"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closeLetterAlert()
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v("\n                        Letter is being generated.  It will be downloaded to your browser's Downloads folder in a few moments.\n                    ")])])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn btn-primary col-sm-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.generateLetter
    }
  }, [_vm._v("Generate Letter")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary col-sm-3 pull-right",
    attrs: {
      "type": "button",
      "name": "cancel"
    },
    on: {
      "click": function($event) {
        _vm.$refs['letterPreviewModal'].close(), _vm.closeLetterAlert()
      }
    }
  }, [_vm._v("Close")])])])])], 1), _vm._v(" "), (_vm.isDebug) ? _c('div', {
    staticClass: "spacer"
  }, [_c('h3', [_vm._v("Debug")]), _vm._v(" "), _c('div', {}, [_vm._v("\n            Body Template:"), _c('br'), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.letterTemplate.templateBody),
      expression: "letterTemplate.templateBody"
    }],
    staticStyle: {
      "width": "1024px"
    },
    attrs: {
      "id": "footer",
      "rows": "6"
    },
    domProps: {
      "value": (_vm.letterTemplate.templateBody)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.letterTemplate, "templateBody", $event.target.value)
      }
    }
  }), _c('br')])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66177ae3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/LetterTemplate.vue
// module id = 951
// module chunks = 1